export default __webpack_public_path__ + "static/media/KL.3b7b8cb4.png";